import {cloneDeep, get} from "lodash";
import memoizeOne from "memoize-one";
import moment from "moment";
import PropTypes from "prop-types";
import React from "react";
import {Modal} from "react-bootstrap";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import {bindActionCreators, compose} from "redux";
import {connectModal} from "redux-modal";
import {getPigHistory} from "../../../actions/rfidHistoryActions";
import {FeedingType} from "../../../constans/feedingTypes";
import {getFakeDataHistoryModal} from "../../../demo/feeding/fakeFunctions";
import {makeGetAggregatedData} from "../../../selectors/aggregatedSelector";
import {makeGetRFIDPigHistory} from "../../../selectors/rfidHistorySelector";
import {localMomentToUTC} from "../../../utils/DateTimeUtils";
import {isUsingFakeData} from "../../../utils/DemoUtils";
import {isBetween} from "../../../utils/MathUtils";
import {getFeedingUnit} from "../../../utils/SettingsUtils";
import {sortDateStrings} from "../../../utils/SortUtils";
import {convertWeightUnitTo, getUnit} from "../../../utils/UnitUtils";
import AggFetcher from "../../agg-fetcher/AggFetcher";
import Chart from "../../basics/chart/Chart";
import InfoBox from "../../basics/info-box/InfoBox";
import TableGrid from "../../basics/table-grid/TableGrid";
import TextSwitch from "../../basics/text-switch/TextSwitch";
import LoadingComponent from "../../loading/LoadingComponent";
import ModalBody from "../ModalBody";
import ModalFooter from "../ModalFooter";
import ModalHeader from "../ModalHeader";

export const ModalName = "feeding-history-modal";

/**
 * przygotowanie danych z shadowa
 * @return {*}
 */
export const getDataSimple = (selectedNodes) => {
    const lastWeekHistory = cloneDeep(
        get(selectedNodes, "[0].lastWeekHistory", [])
    ).map((o) => ({
        plannedUsage: o.plannedUsage || 0,
        usage: o.usage || 0,
        time: o.date,
        name: moment(o.date).format("DD.MM.YY"),
    }));
    lastWeekHistory.sort((o2, o1) => o1.time - o2.time);
    return lastWeekHistory;
};

/**
 * przygotowanie danych z agg data
 * @return {unknown[]}
 */
export const getDataExtended = (
    aggregatedData,
    type,
    _animalDataKey,
    params
) => {
    const result = {};
    if (type === FeedingType.GROUP) {
        aggregatedData.forEach(
            ({feed, toFeed, time: timeLocal, additionalFeed}) => {
                const time = +localMomentToUTC(timeLocal);
                if (
                    isBetween(
                        time,
                        params.AggDataTimeFrom,
                        params.AggDataTimeTo
                    )
                ) {
                    if (result[time]) {
                        result[time].usage += feed;
                        result[time].extraUsage += additionalFeed;
                        !result[time].plannedUsage &&
                            (result[time].plannedUsage = toFeed);
                    } else {
                        result[time] = {};
                        result[time].usage = feed;
                        result[time].extraUsage = additionalFeed;
                        result[time].plannedUsage = toFeed;
                        result[time].time = time;
                        result[time].name = moment.utc(time).format("DD.MM.YY");
                    }
                }
            }
        );
    } else if (type === FeedingType.INDIVIDUAL) {
        for (let row of aggregatedData) {
            let usage = 0;
            let plannedUsage = 0;
            let extraUsage = 0;
            let time = row.AggTi;
            if (isBetween(time, params.AggDataTimeFrom, params.AggDataTimeTo)) {
                const AnmID = _animalDataKey.AnmID;
                switch (row.AggDt.length) {
                    //jesli nie mamy danych to 0
                    case 0:
                        break;
                    //jesli jest jedna dana to znaczy ze raczej stanowisko bylo uruchomione i na slepo przypisujemy
                    case 1:
                        plannedUsage = row.AggDt[0].PCons;
                        usage = row.AggDt[0].Cons.reduce(
                            (b, a) => (!a.ADD ? a.C || 0 : 0) + b,
                            0
                        );
                        extraUsage = row.AggDt[0].Cons.reduce(
                            (b, a) => (!!a.ADD ? a.C || 0 : 0) + b,
                            0
                        );
                        break;
                    //jesli jest wiecej niz 1 tzn ze mozliwe ze jest karmienie rfid i wtedy tylko dla AnmID poszukujemy
                    default:
                        if (AnmID) {
                            const animalRow = row.AggDt.find(
                                (o) => o.AnmID === AnmID
                            );
                            if (animalRow) {
                                plannedUsage = animalRow.PCons;
                                usage = animalRow.Cons.reduce(
                                    (b, a) => (!a.ADD ? a.C : 0) + b,
                                    0
                                );
                                extraUsage = animalRow.Cons.reduce(
                                    (b, a) => (!!a.ADD ? a.C : 0) + b,
                                    0
                                );
                            }
                        } else {
                            plannedUsage = row.AggDt[0].PCons;
                            usage = row.AggDt[0].Cons.reduce(
                                (b, a) => (!a.ADD ? a.C || 0 : 0) + b,
                                0
                            );
                            extraUsage = row.AggDt[0].Cons.reduce(
                                (b, a) => (!!a.ADD ? a.C || 0 : 0) + b,
                                0
                            );
                        }
                        break;
                }
                if (result[time]) {
                    result[time].usage += usage;
                    result[time].extraUsage += extraUsage;
                    !result[time].plannedUsage &&
                        (result[time].plannedUsage = plannedUsage);
                } else {
                    result[time] = {};
                    result[time].usage = usage;
                    result[time].extraUsage = extraUsage;
                    result[time].plannedUsage = plannedUsage;
                    result[time].time = time;
                    result[time].name = moment.utc(time).format("DD.MM.YY");
                }
            }
        }
    }
    return Object.values(result).sort((o2, o1) => o1.time - o2.time);
};

class FeedingHistoryModal extends React.Component {
    constructor(props) {
        super(props);
        this.demo = isUsingFakeData();
        this.unit = getFeedingUnit();
        this.params = {
            AggDataTimeFrom: +moment.utc().startOf("day").subtract(30, "days"),
            AggDataTimeTo: +moment.utc().startOf("day"),
        };
        this.state = {
            showChart: true,
        };
    }

    componentDidMount() {
        const {getPigHistory, type, _animalDataKey} = this.props;
        // pobieramy historie karmien rfid prosto z gejtwejów
        if (!this.demo && type === FeedingType.GROUP) {
            getPigHistory(_animalDataKey);
        }
    }

    getData = () => {
        const {selectedNodes, aggregated, type, _animalDataKey} = this.props;
        if (this.demo) return getFakeDataHistoryModal(selectedNodes);
        return getDataExtended(
            aggregated.data,
            type,
            _animalDataKey,
            this.params
        );
    };

    formatTime = (value) => moment.utc(value).format("DD.MM.YY");
    formatForage = (value) =>
        convertWeightUnitTo(value, {
            showUnit: true,
            fixed: this.unit ? 2 : 0,
            unit: this.unit,
        });
    formatPlannedUsage = (value) =>
        `${(value.plannedUsage ? (100 * (value.usage + value.extraUsage || 0)) / value.plannedUsage : 0).toFixed(0)}%`;

    formatWeight = (value) =>
        convertWeightUnitTo(value, {
            showUnit: false,
            rawValue: true,
            acceptNil: true,
            unit: this.unit,
            fixed: this.unit ? 2 : 0,
            defaultValue: 0,
        });

    getUnit = () => {
        return getUnit("weight", this.unit);
    };

    handleChange = (index) => {
        this.setState({
            showChart: index !== 0,
        });
    };

    getTableHeaders = memoizeOne((t) => {
        return [
            {
                name: t("date"),
                field: "time",
                valueFormatter: this.formatTime,
                customSort: sortDateStrings,
            },
            {
                name: t("settings.fedByCurve"),
                field: "usage",
                valueFormatter: this.formatForage,
            },
            {
                name: t("settings.fedByExtraFeeding"),
                field: "extraUsage",
                valueFormatter: this.formatForage,
                itemClassName: ({object}) => object.extraUsage && "fw-bold",
            },
            {
                name: t("modals.feedingHistoryModal.dailyPercentage"),
                field: "",
                valueFormatter: this.formatPlannedUsage,
            },
        ];
    });

    getChartHeaders = memoizeOne((t) => {
        return [
            {
                color: "blue",
                dataKey: "usage",
                chartType: "Bar",
                name: t("settings.fedByCurve"),
                unit: this.getUnit(),
                valueConverter: this.formatWeight,
                opacity: 1,
                stack: "feed",
            },
            {
                color: "orange",
                dataKey: "extraUsage",
                chartType: "Bar",
                name: t("settings.fedByExtraFeeding"),
                unit: this.getUnit(),
                valueConverter: this.formatWeight,
                opacity: 1,
                stack: "feed",
            },
            {
                color: "green",
                dataKey: "plannedUsage",
                name: t("modals.feedingHistoryModal.curve"),
                chartType: "Area",
                unit: this.getUnit(),
                valueConverter: this.formatWeight,
                opacity: 0.1,
            },
        ];
    });

    getOptions = memoizeOne((t) => {
        return [
            {
                name: t("chart"),
                value: 1,
            },
            {
                name: t("table"),
                value: 0,
            },
        ];
    });

    render() {
        const {
            show,
            handleHide,
            t,
            selectedNodes,
            aggregated: {fetching},
            type,
            _deviceDataKey,
        } = this.props;
        const history = this.getData();
        const {showChart} = this.state;
        const title = get(
            selectedNodes,
            "[0].name",
            t("modals.feedingHistoryModal.feedingHistory")
        );
        const headers = showChart
            ? this.getChartHeaders(t)
            : this.getTableHeaders(t);
        const options = this.getOptions(t);
        return (
            <Modal onHide={handleHide} show={show} size={"lg"}>
                <ModalHeader title={title} onCloseClick={handleHide} />
                <ModalBody className={ModalName}>
                    <LoadingComponent isLoading={fetching && !history.length} />
                    <InfoBox boxColor={"info"}>
                        {t("deviceRows.siloses.siloRow.lastXdays", {
                            count: 30,
                        })}
                    </InfoBox>
                    <TextSwitch
                        className={"mb-4"}
                        onChange={this.handleChange}
                        value={+showChart}
                        options={options}
                    />
                    <div>
                        {!this.demo && type === FeedingType.INDIVIDUAL && (
                            <AggFetcher
                                device={_deviceDataKey.device}
                                showNewestDate={false}
                                key={`${_deviceDataKey.DevID}_${_deviceDataKey.index}`}
                                start={this.params.AggDataTimeFrom}
                                end={this.params.AggDataTimeTo}
                                index={_deviceDataKey.index}
                                isDuration={true}
                            />
                        )}
                        {!!showChart && (
                            <div style={{height: "20rem"}}>
                                <Chart
                                    data={history.slice(0).reverse()}
                                    type={"Composed"}
                                    dataDef={headers}
                                    Xaxis={{
                                        name: t("day"),
                                        dataKey: "name",
                                    }}
                                    Yaxis={{
                                        name: t("forageAmount"),
                                        domain: [0, "auto"],
                                    }}
                                />
                            </div>
                        )}
                        {!showChart && (
                            <TableGrid headers={headers} data={history} />
                        )}
                    </div>
                </ModalBody>
                <ModalFooter
                    hasConfirmButton={false}
                    onCloseClick={handleHide}
                />
            </Modal>
        );
    }
}

FeedingHistoryModal.propTypes = {
    node: PropTypes.object.isRequired,
};

const makeMapStateToProps = (ownState, ownProps) => {
    const getAggregated = makeGetAggregatedData();
    const getRFIDPigHistory = makeGetRFIDPigHistory();
    const _animalDataKey = {
        RFID: get(ownProps, "selectedNodes[0].RFID"),
        AnmID: get(ownProps, "selectedNodes[0].animal.AnmID"),
    };
    const _deviceDataKey = {
        device: get(ownProps, "selectedNodes[0].device"),
        DevID: get(ownProps, "selectedNodes[0].receiver.deviceId"),
        GwID: get(ownProps, "selectedNodes[0].receiver.gatewayId"),
        index: get(ownProps, "selectedNodes[0].receiver.index"),
    };
    return (state, props) => {
        return {
            forages: state.settings.forage,
            aggregated:
                props.type === FeedingType.INDIVIDUAL
                    ? getAggregated(state, _deviceDataKey)
                    : getRFIDPigHistory(state, _animalDataKey),
            _animalDataKey,
            _deviceDataKey,
        };
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
        ...bindActionCreators({getPigHistory}, dispatch),
    };
};

export default compose(
    withTranslation(),
    connectModal({name: ModalName}),
    connect(makeMapStateToProps, mapDispatchToProps)
)(FeedingHistoryModal);
